import { useDismissed } from "@/hooks/use-dismissed";

const DISMISS_KEY = "flaneriet:how-to-read-dismissed";

/**
 * Manifest – den tydelige "det er derfor vi er her". Én rolig sætning,
 * uden portræt eller signatur (de bor nu i HowToRead lige under).
 *
 * Forsvinder sammen med "Sådan læses"-blokken når brugeren har bekræftet,
 * at konceptet er forstået.
 */
export function HomeManifest() {
  const { ready, dismissed } = useDismissed(DISMISS_KEY);
  if (ready && dismissed) return null;

  return (
    <section className="border-b border-rule" aria-label="Manifest">
      <div className="max-w-[820px] mx-auto text-center pt-12 pb-10 md:pt-[52px] md:pb-[42px] px-1">
        <p className="font-serif font-light text-[20px] md:text-[26px] leading-[1.5] text-ink-body m-0">
          Et sted uden hastighed. Jeg lærer en AI at samle det, der er værd at bruge tid på –
          og at lade alt det andet ligge.{" "}
          <span className="italic text-ink-soft">
            Ingen feed, ingen notifikationer. En samling, til når du har tid.
          </span>
        </p>
      </div>
    </section>
  );
}
